/**
 * 设备故障统计分析
 * 预留：POST /api/produce/kanban/device-fault-analysis
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/device-fault-analysis'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

/**
 * @returns {Promise<{ list: array }>}
 */
export function fetchDeviceFaultAnalysis(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
